import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const useMdDown = () => {
    const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
};

export default useMdDown;
